"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RouteGeometry;

var _coreUtils = _interopRequireDefault(require("@opentripplanner/core-utils"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLeaflet = require("react-leaflet");

var utils = _interopRequireWildcard(require("../../utils"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  leafletPathType,
  transitVehicleType
} = _coreUtils.default.types;
/**
 * vehicle geometry presentational component that creates a map overlay for the line
 * geometry showing the travel pattern of a vehicle
 */

function RouteGeometry(props) {
  const {
    pattern,
    zoom,
    selectedVehicle
  } = props;
  const {
    highlightColor,
    lowlightColor
  } = props;
  let {
    highlight,
    lowlight
  } = props;
  utils.linterIgnoreTheseProps(zoom);
  if (highlightColor) highlight = utils.setColor(highlightColor, highlight);
  if (lowlightColor) lowlight = utils.setColor(lowlightColor, lowlight);
  const splitCoord = selectedVehicle && utils.getVehicleCoordinates(selectedVehicle);
  const pt = utils.findPointOnLine(splitCoord, pattern.data);
  const geom = utils.splitLineGeometry(pattern.data, pt, pattern.id);
  const segments = utils.makeSplitLine(geom, highlight, lowlight);

  let retVal = /*#__PURE__*/_react.default.createElement(_reactLeaflet.FeatureGroup, null);

  if (segments && segments.length === 2) {
    retVal = /*#__PURE__*/_react.default.createElement(_reactLeaflet.FeatureGroup, null, segments);
  }

  return retVal;
}

RouteGeometry.propTypes = {
  /** map zoom: is part of the props due to redrawing this layer on map zoom */
  zoom: _propTypes.default.number,

  /** optional vehicle record for the (tracked) vehicle */
  selectedVehicle: transitVehicleType,

  /** line geometry, ala { id: <tripId>, data: [[lat, lon], [45.50,-122.41], etc..] } */
  pattern: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    data: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.number)).isRequired
  }),

  /** color of the *to be travelled* portion of tracked route geom */
  highlightColor: _propTypes.default.string,

  /** color of the *already travelled* tracked vehicle route (see highlightColor) */
  lowlightColor: _propTypes.default.string,

  /** line styling options for the to be traveled part of the line geom */
  highlight: leafletPathType,

  /** line styling options for the already traveled portion of the line geom */
  lowlight: leafletPathType
};
RouteGeometry.defaultProps = {
  zoom: 13,
  pattern: null,
  selectedVehicle: null,
  highlightColor: null,
  lowlightColor: null,
  highlight: {
    color: "#00bfff",
    weight: 5.0,
    opacity: 0.85
  },
  lowlight: {
    color: "#777",
    weight: 5.0,
    opacity: 0.7,
    dashArray: "1, 10, 1, 10"
  }
};
//# sourceMappingURL=index.js.map